import { computed } from 'vue';

import type { InjectionWithDefaults } from '../../../types/utils';
import type { ModuleInjection } from './Module.types';

export const MODULE_INJECTION: InjectionWithDefaults<ModuleInjection> = Object.freeze({
  key: Symbol('MODULE_INJECTION_KEY'),
  defaults: {
    variant: undefined,
    includeDataviewPagination: computed(() => false),
  },
});
